import { http } from '@pendo/http';

export function fetchTrackTypes () {
    return http.get('api/s/_SID_/tracktype?expand=*');
}

export function fetchTrackType (trackTypeId) {
    return http.get(`api/s/_SID_/tracktype/${trackTypeId}`);
}

export function updateTrackType (trackType, apply) {
    return http.put(`api/s/_SID_/tracktype/${trackType.id}`, trackType).then(async (updatedTrackType) => {
        if (apply) {
            try {
                await startProcessingTrackType(trackType.id);
            } catch (error) {
                const reverseProcessingJobIsAlreadyRunning = error.response.status === 409;
                if (!reverseProcessingJobIsAlreadyRunning) {
                    throw error;
                }
            }
        }

        return updatedTrackType;
    });
}

export function createTrackType (newTrackType) {
    return http.post('api/s/_SID_/tracktype', newTrackType).then((savedTrackType) => {
        http.post(`api/s/_SID_/tracktype/${savedTrackType.id}/apply`, {});

        return savedTrackType;
    });
}

export function deleteTrackType (trackTypeId) {
    return http.delete(`api/s/_SID_/tracktype/${trackTypeId}`);
}

export function startProcessingTrackType (trackTypeId) {
    return http.post(`api/s/_SID_/tracktype/${trackTypeId}/apply`, {});
}
